<template>
  <div class="tw-bg-gray-50 tw-rounded-lg tw-p-3">
    <div class="tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wide tw-mb-1">Bewoner</div>
    <button
      v-if="meterDetail.client_name"
      class="tw-flex tw-items-center tw-gap-1 tw-text-left hover:tw-text-blue-600 tw-transition-colors"
      @click="(meterDetail.client_email || meterDetail.client_phone) && (showContact = !showContact)"
    >
      <span class="tw-font-medium tw-text-gray-800">{{ meterDetail.client_name }}</span>
      <svg
        v-if="meterDetail.client_email || meterDetail.client_phone"
        class="tw-w-3.5 tw-h-3.5 tw-text-gray-400 tw-transition-transform"
        :class="showContact ? 'tw-rotate-180' : ''"
        fill="none" stroke="currentColor" viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
    <div v-if="showContact && (meterDetail.client_email || meterDetail.client_phone)" class="tw-flex tw-flex-col tw-gap-0.5 tw-ml-1">
      <a v-if="meterDetail.client_email" :href="`mailto:${meterDetail.client_email}`" class="tw-text-blue-600 hover:tw-underline tw-text-xs">{{ meterDetail.client_email }}</a>
      <a v-if="meterDetail.client_phone" :href="`tel:${meterDetail.client_phone}`" class="tw-text-blue-600 hover:tw-underline tw-text-xs">{{ meterDetail.client_phone }}</a>
    </div>
    <div v-if="!meterDetail.client_name" class="tw-text-sm tw-text-gray-400">Geen bewoner gekoppeld</div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  meterDetail: { type: Object, required: true },
})

const showContact = ref(false)
</script>
